import React from 'react'
import FaFacebook from 'react-icons/lib/fa/facebook-official'
import FaMeetup from '../components/icons/fa-meetup'

export default () => (
  <footer>
    <a href="https://www.facebook.com/events/171186623633233/" target="_blank"><FaFacebook /></a>
    <a href="https://www.meetup.com/Deny-Boredom-Denver/events/245838723/" target="_blank"><FaMeetup /></a>
  </footer>
)



// WEBPACK FOOTER //
// ./src/layouts/footer.js